import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Observable} from 'rxjs';
import {Session} from './Session';

@Injectable({
  providedIn: 'root'
})
export class LoggedInActivator implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (Session.hasSession() && !Session.isSessionExpired()) {
      return true;
    }

    Session.setLastVisitedUrl(state.url);
    return this.router.createUrlTree(['/login']);
  }
}
